import CustomName from './CustomName'

export default CustomName
